/* eslint-disable */
import './public-path'
import './styles/style.scss'
import './plugins/zoom-ui'
import permission from './plugins/permission'
import './permission' // permission control
import router from './router/index'
import Vue from 'vue'
import App from './App.vue'
import VueClipboard from 'vue-clipboard2'
import * as echarts from 'echarts'
Vue.use(echarts)
Vue.prototype.$echarts = echarts
Vue.use(VueClipboard)

// const Vue = window.Vue
Vue.config.productionTip = false

Vue.directive('permission', permission)
Vue.prototype.resetSetItem = function (type, key, data) {
    if (type === 'namespace') {
        var newStorageEvent = document.createEvent('StorageEvent')
        const storage = {
            setItem: function (k, val) {
                localStorage.setItem(k, val)
                newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null)
                window.dispatchEvent(newStorageEvent)
            }
        }
        return storage.setItem(key, data)
    }
}
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
